import graphql from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";

import { useAssignPaymentToPackageMutation } from "./__generated__/useAssignPaymentToPackageMutation.graphql";

export const useAssignPaymentToPackage = () => {
  const [assignPaymentMethodToPackageMutation, isAssigning] =
    useMutation<useAssignPaymentToPackageMutation>(
      UseAssignPaymentToPackageMutationString
    );

  const assignPaymentMethodToPackage = (
    input: { id: string; squareCardId: string },
    onComplete?: () => void,
    onError?: (error: Error) => void
  ) => {
    assignPaymentMethodToPackageMutation({
      variables: { input },
      onCompleted: (res) => {
        if (res.assignPaymentMethodToPackage?.success) {
          onComplete && onComplete();
        } else {
          if (onError) {
            const error = new Error(
              res.assignPaymentMethodToPackage?.errors?.[0]?.code ||
                "Unknown error"
            );
            onError(error);
          }
        }
      },
    });
  };

  return [assignPaymentMethodToPackage, isAssigning] as const;
};

const UseAssignPaymentToPackageMutationString = graphql`
  mutation useAssignPaymentToPackageMutation(
    $input: AssignPaymentMethodToPackageInput!
  ) {
    assignPaymentMethodToPackage(input: $input) {
      success
      memberPackage {
        id
        squareCard {
          id
          lastFour
          cardBrand
          expMonth
          expYear
        }
      }
      errors {
        code
        field
      }
    }
  }
`;
